export function BackgroundOrbits() {
  return (
    <div className="background-orbits" aria-hidden="true">
      <svg
        className="orbit orbit-left"
        viewBox="0 0 560 420"
        preserveAspectRatio="none"
      >
        {[0, 1, 2, 3, 4].map((line) => (
          <path
            key={line}
            d={`M-40 ${80 + line * 30} C 100 ${250 + line * 16}, 310 ${260 + line * 10}, 610 ${350 + line * 8}`}
          />
        ))}
      </svg>
      <svg
        className="orbit orbit-right"
        viewBox="0 0 560 420"
        preserveAspectRatio="none"
      >
        {[0, 1, 2, 3, 4].map((line) => (
          <path
            key={line}
            d={`M600 ${30 + line * 25} C 430 ${255 + line * 12}, 260 ${270 + line * 8}, -40 ${350 + line * 9}`}
          />
        ))}
      </svg>
      <span className="orbit-dot dot-left" />
      <span className="orbit-dot dot-right" />
    </div>
  );
}
